await themeComponent(theme.components['mc-element'], false);

class McCart extends McElement {
	constructor() {
		super();
	}
	connectedCallback() {}
}
if (!window.customElements.get('mc-cart')) {
	window.customElements.define('mc-cart', McCart);
}
window.McCart = McCart;

class McCartChanger extends McElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.refresher = document.querySelector('#general-refresher');
		this.input = this.querySelector(this.dataset.target);

		if (!this.input) {
			console.warn('[McCartChanger] No input found for target:', this.dataset.target);
			return;
		}

		// Quantity change handling
		this.input.addEventListener(MCEVENTS.QUANTITY_CHANGED, (event) => {
			console.log('[McCartChanger] Quantity change event received!');
			this.cartChange({
				what: 'quantity',
				who: this.dataset.line,
				qty: event.detail.value,
			});
		});

		// Variant change handling
		if (this.input.name === 'variant') {
			console.log('[McCartChanger] Locked onto variant input:', this.input);

			this.input.addEventListener('change', () => {
				const selectedOption = this.input.options[this.input.selectedIndex];
				const variantId = selectedOption?.dataset.id || selectedOption?.value;

				if (!variantId || isNaN(parseInt(variantId))) {
					console.error('[McCartChanger] Invalid variant ID selected:', variantId);
					return;
				}

				console.log('[McCartChanger] Variant change to:', variantId);

				this.cartChange({
					what: 'variant',
					who: this.dataset.line,
					which: variantId,
					qty: this.dataset.quantity || 1,
				});
			});
		}
	}

	cartChange = (options) => {
		switch (options.what) {
			case 'quantity':
				McShopify.updateCartLine({
					id: options.who,
					quantity: options.qty,
					onComplete: this.initiateReload,
				});
				break;

			case 'variant':
                McShopify.updateCartLine({
                    id: options.who,
                    quantity: 0,
                    onComplete: () => {
                        // Add the new variant using items array
                        McShopify.addToCart({
                            items: [{
                            id: options.which,
                            quantity: parseInt(options.qty, 10) || 1
                        }],
                        onComplete: this.initiateReload
                    });
                }
            });
            break;
            
			default:
				console.warn('[McCartChanger] Unknown cartChange type:', options.what);
		}
	};

	initiateReload = () => {
		const url = new URL(window.location.href);
		axios({
			url: url,
			method: 'get',
		}).then((response) => {
			this.refresher.reload(response.data);
		});
	};
}

if (!window.customElements.get('mc-cart-changer')) {
	window.customElements.define('mc-cart-changer', McCartChanger);
}
window.McCartChanger = McCartChanger;
